import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Container, Nav, Tab, Toast } from 'react-bootstrap';
import AddMaker from '../AddMaker';
import CarModelManager from '../CarModelManager';
import AddModel from '../AddModel';

const CarTable = () => {
    const [cars, setCars] = useState([]);
    const [showSuccessToast, setShowSuccessToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    useEffect(() => {
        const fetchCars = async () => {
            try {
                const response = await axios.get('https://motor-easy.clickbooster.io/api/cars');
                if (response.data && Array.isArray(response.data.cars)) {
                    setCars(response.data.cars);
                } else {
                    setToastMessage('Unexpected response data format');
                    setShowSuccessToast(true);
                }
            } catch (error) {
                setToastMessage('Error fetching car data');
                setShowSuccessToast(true);
            }
        };

        fetchCars();
    }, []);

    return (
        <>
            <Container className="mt-4">
                {/* Toast Notification */}
                <Toast
                    onClose={() => setShowSuccessToast(false)}
                    show={showSuccessToast}
                    delay={3000}
                    autohide
                    bg="danger"
                    className="mb-2"
                >
                    <Toast.Body>{toastMessage}</Toast.Body>
                </Toast>

                {/* Pills Navigation */}
                <Tab.Container id="left-tabs-example" defaultActiveKey="addMaker">
                    <Nav variant="pills" className="justify-content-center mb-4">
                        <Nav.Item>
                            <Nav.Link eventKey="addMaker">Add Maker</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="addModel">Add Model</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="carModelManager">Car Model Manager</Nav.Link>
                        </Nav.Item>
                    </Nav>

                    {/* Pills Content */}
                    <Tab.Content>
                        <Tab.Pane eventKey="addMaker">
                            <AddMaker />
                        </Tab.Pane>
                        <Tab.Pane eventKey="addModel">
                            <AddModel />
                        </Tab.Pane>
                        <Tab.Pane eventKey="carModelManager">
                            <CarModelManager />
                        </Tab.Pane>
                    </Tab.Content>
                </Tab.Container>
            </Container>
        </>
    );
};

export default CarTable;
